import {
  Pagination,
  Table,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
  Typography,
} from '@occc/ui-design-system';

import { ConnectionHistoryItem } from './connection-history-item.component';
import { ConnectionHistoryTableProps } from '../types';

export const ConnectionHistoryTable = ({
  data,
  paginationProps,
  timezone,
  loading,
}: ConnectionHistoryTableProps) => {
  if (loading && !data?.length) {
    return <Typography p={2}>Loading...</Typography>;
  }

  if (!loading && !data?.length) {
    return <Typography p={2}>No activity log messages available</Typography>;
  }

  return (
    <>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Connected at</TableCell>
            <TableCell>Disconnected at</TableCell>
            <TableCell>Connection Duration</TableCell>
            <TableCell>Sent/Received</TableCell>
            <TableCell>Disconnect Reason</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {data?.map((node) => (
            <ConnectionHistoryItem
              key={node.connectedAt}
              connectedAt={node.connectedAt}
              disconnectedAt={node.disconnectedAt}
              sent={node.messagesSent}
              connectionDuration={node.connectionDurationMs}
              received={node.messagesReceived}
              disconnectReason={node.disconnectionAction}
              timezone={timezone}
            />
          ))}
        </TableBody>
      </Table>
      <Pagination {...paginationProps} />
    </>
  );
};
